import { memo } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CreatePoll, ViewPolls } from './partials';

import { OTooltip } from '@src/shared';
import usePollsBox from './usePollsBox';

import './pollsBox.scss';

const PollsBox = () => {
  const { pollsLength, activePollView, handleChangeView, canUserCreatePoll } = usePollsBox();

  return (
    <div className="polls-box-container">
      {canUserCreatePoll && (
        <div className="toggle-container">
          <ToggleButtonGroup
            color="primary"
            value={activePollView}
            exclusive
            fullWidth
            classes={{
              root: 'toggle-group-container',
              grouped: 'toggle-item',
            }}
            onChange={(_, view) => handleChangeView(view)}
            aria-label="selected view"
          >
            <OTooltip title="Create new poll">
              <ToggleButton
                value="create"
                classes={{
                  selected: 'selected-item',
                }}
              >
                Create new poll
              </ToggleButton>
            </OTooltip>
            <OTooltip title="View existing polls">
              <ToggleButton
                value="view"
                classes={{
                  selected: 'selected-item',
                }}
              >
                View polls ({pollsLength})
              </ToggleButton>
            </OTooltip>
          </ToggleButtonGroup>
        </div>
      )}
      <div className="box-body">
        {/* keep mounted in case we need to save the state when change view*/}
        <CreatePoll isHidden={activePollView !== 'create'} />
        {activePollView === 'view' && <ViewPolls />}
      </div>
    </div>
  );
};

export default memo(PollsBox);
